function normalizeFromToValue(value) {
    const { firstInput, secondInput } = value;

    if (null !== secondInput) {
        return secondInput;
    }

    if (null !== firstInput) {
        return firstInput;
    }

    return null;
}

export const normalizeStep = (values) => {
    const { from, to, bikes } = values;

    return {
        ...values,
        from: normalizeFromToValue(from),
        to: normalizeFromToValue(to),
        bikes: parseInt(bikes),
        driverComment: null
    };
};
